import React, { useMemo } from "react";

import { formatDate } from "../../services/date";

import InternalModal from "../../commons/InternalModal";

import Table from "./Table";
import KpiComposition from "./KpiComposition";

const MemberHealthSelfReportedMetricsModal = ({ kpi, onClose }) => {

  const columns = useMemo(() => [
    {
      id: "title",
      accessorKey: "title",
      header: () => <span>{I18n.t("insights.page.table.metric.title")}</span>,
      cell: info => info.getValue() ? I18n.t(`insights.kpis.${info.getValue()}`) : null,
      enableSorting: false
    },
    {
      id: "scoring_scale",
      accessorKey: "scoring_scale",
      header: () => <span>{I18n.t("insights.page.table.scoring_scale.title")}</span>,
      cell: info => info.getValue() ? info.getValue() : null,
      enableSorting: false
    },
    {
      id: "created_at",
      accessorKey: "created_at",
      header: () => <span>{I18n.t("insights.page.table.date.title")}</span>,
      cell: info => info.getValue() ? formatDate(info.getValue()) : null,
      enableSorting: false
    },
    {
      id: "value",
      accessorKey: "value",
      header: () => <span>{I18n.t("insights.page.table.value.title")}</span>,
      cell: info => info.getValue() ? info.getValue() : null,
      enableSorting: false
    },
    {
      id: "normalized",
      accessorKey: "normalized",
      header: () => <span>{I18n.t("insights.page.table.normalized_score.title")}</span>,
      cell: info => info.getValue() ? parseFloat(info.getValue()).toFixed(2) : null,
      enableSorting: false
    }
  ], []);

  const renderContent = () => kpi && (
    <div className="content">
      <Table
        columns={columns}
        data={kpi?.self_reported_metrics}
        loading={false}
      />
    </div>
  );

  return (
    <InternalModal
      type="member-health-self-reported-metrics"
      isModalOpen={Boolean(kpi)}
      hideModal={onClose}
      showModalBody={false}
      component={renderContent()}
      backdrop
    />
  );
}

export default MemberHealthSelfReportedMetricsModal;
